/** @format */

import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';

export const PaddingContainer = styled(Box)(({theme}) => ({
  padding: theme.spacing(6),
}));

export const SegmentsContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(8),
  marginTop: theme.spacing(8),
  paddingBottom: theme.spacing(50),
}));

export const FullDescription = styled(Box)(({theme}) => ({
  padding: theme.spacing(4, 0),
  display: 'flex',
  gap: theme.spacing(4),
}));

export const DescriptionHeader = styled(Box)(({theme}) => ({
  fontSize: '18px',
  lineHeight: '22px',
  fontWeight: 500,
  color: theme.palette.semantic_dark?.surface?.onSurfaceLight,
  marginBottom: theme.spacing(2),
}));

export const ChartsContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  gap: '1px',
  overflowX: 'auto',
  overflowY: 'hidden',
  marginTop: theme.spacing(6),
  '& > *': {
    flex: 1,
    minWidth: 463,
  },
}));

export const CampaignCellContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '8px',
  position: 'relative',
  // Растягиваем на всю ячейку, компенсируя padding ячейки (12px 32px)
  margin: theme.spacing(-1.5, -4),
  padding: theme.spacing(1.5, 4),
  minHeight: '62px', // высота ячейки по умолчанию

  '&:hover .filter-icon-button': {
    opacity: 1,
    visibility: 'visible',
  },
}));

export const FilterIconButton = styled(Box)(({theme}) => ({
  position: 'absolute',
  right: 0,
  top: 0,
  bottom: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  transition: 'all 0.2s',
  opacity: 0,
  visibility: 'hidden',
  width: '40px',

  '.campaign-cell-container:hover &': {
    background: `linear-gradient(90deg, ${theme.palette?.semantic_dark?.surface.surface1} 0%, ${theme.palette?.semantic_dark?.primary.activeContainer} 100%)`,
  },

  '&:hover': {
    background: `${theme.palette.semantic_dark?.primary?.hover} !important`,
  },

  '& svg': {
    fontSize: '18px',
    color: theme.palette.semantic_dark?.primary?.on,
  },
}));

export const KpiAndBudgetCellContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  alignItems: 'center',
}));

export const ToggleDetailsButton = styled(Box)(({theme}) => ({
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '14px',
  color: theme.palette.semantic_dark?.primary?.main,
  userSelect: 'none',
  marginTop: theme.spacing(3),
  '&:hover': {
    textDecoration: 'underline',
  },
}));

